export const formDefaultValues = {
  subscriptionPlan: '',
  price: '',
  tax: '',
  minAgendas: '',
  maxAgendas: '',
  country: '-',
  visible: true,
}
